import { useFonts } from 'expo-font';
import { Platform } from 'react-native';

import { WEB_FONT_MAP } from './web-font-map';

/**
 * Native: fonts come from linked assets (react-native.config.js). Web: `expo-font` injects @font-face.
 */
export function useAppFonts(): boolean {
  const [loaded] = useFonts(Platform.OS === 'web' ? WEB_FONT_MAP : {});
  return Platform.OS !== 'web' || loaded;
}
